module.exports = __webpack_public_path__ + "static/media/app.3e1f9321.png";